<template>
  <div style="padding: 15px 24px;padding-top:5px;background: #fff;">
    <a-tabs defaultActiveKey="1" @change="changeTabSelect">
      <a-tab-pane tab="我的菜品库" key="1">
        <own-menu :tabIndex="tabIndex"></own-menu>
      </a-tab-pane>
      <a-tab-pane tab="公共菜品库" key="2">
        <public-menu :tabIndex="tabIndex"></public-menu>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import ownMenu from './tabs/own-menu'
import publicMenu from './tabs/public-menu'




export default {
  data() {
    return {
      tabIndex: '1'
    }
  },
  methods: {
    changeTabSelect(key) {
      setTimeout(() => {
        this.tabIndex = key
      }, 10)
    }
  },
  components: {
    ownMenu,
    publicMenu
  }
}
</script>